"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var component_library_1 = require("@kaizen/component-library");
var draft_badge_1 = require("@kaizen/draft-badge");
var loading_spinner_1 = require("@kaizen/loading-spinner");
var GenericButton_module_scss_1 = __importDefault(require("./GenericButton.module.scss"));
// We're treating custom props as anything that is kebab cased.
// This is so we can support properties like aria-* or data-*
var getCustomProps = function (props) {
    var keys = Object.keys(props).filter(function (k) { return k.indexOf("-") !== -1; });
    return keys.reduce(function (acc, val) {
        acc[val] = props[val];
        return acc;
    }, {});
};
var GenericButton = (0, react_1.forwardRef)(function (props, ref) {
    var buttonRef = (0, react_1.useRef)();
    (0, react_1.useImperativeHandle)(ref, function () { return ({
        focus: function () {
            var _a;
            (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }); });
    var determineButtonRenderer = function () {
        if (props.component) {
            return renderCustomComponent(props.component, props);
        }
        if (props.href && !props.disabled && !props.working) {
            return renderLink(props, buttonRef);
        }
        return renderButton(props, buttonRef);
    };
    return (react_1["default"].createElement("span", { className: (0, classnames_1["default"])(GenericButton_module_scss_1["default"].container, props.fullWidth && GenericButton_module_scss_1["default"].fullWidth), "aria-live": "polite" }, determineButtonRenderer()));
});
GenericButton.defaultProps = {
    iconPosition: "start",
    iconButton: false,
    primary: false,
    secondary: false,
    newTabAndIUnderstandTheAccessibilityImplications: false,
    disableTabFocusAndIUnderstandTheAccessibilityImplications: false,
    type: "button"
};
GenericButton.displayName = "GenericButton";
var renderCustomComponent = function (CustomComponent, props) {
    var id = props.id, disabled = props.disabled, href = props.href, onClick = props.onClick, onFocus = props.onFocus, onBlur = props.onBlur, rest = __rest(props, ["id", "disabled", "href", "onClick", "onFocus", "onBlur"]);
    var customProps = getCustomProps(rest);
    return (react_1["default"].createElement(CustomComponent, __assign({ id: id, className: buttonClass(props), disabled: disabled, href: href, onClick: onClick, onFocus: onFocus, onBlur: onBlur, "aria-label": generateAriaLabel(props) }, customProps), renderContent(props)));
};
var renderButton = function (props, ref) {
    var id = props.id, disabled = props.disabled, onClick = props.onClick, onMouseDown = props.onMouseDown, type = props.type, disableTabFocusAndIUnderstandTheAccessibilityImplications = props.disableTabFocusAndIUnderstandTheAccessibilityImplications, onFocus = props.onFocus, onBlur = props.onBlur, form = props.form, formAction = props.formAction, formMethod = props.formMethod, formEncType = props.formEncType, formTarget = props.formTarget, formNoValidate = props.formNoValidate, rest = __rest(props, ["id", "disabled", "onClick", "onMouseDown", "type", "disableTabFocusAndIUnderstandTheAccessibilityImplications", "onFocus", "onBlur", "form", "formAction", "formMethod", "formEncType", "formTarget", "formNoValidate"]);
    var customProps = getCustomProps(rest);
    return (react_1["default"].createElement("button", __assign({ 
        // eslint-disable-next-line react/button-has-type
        type: type, id: id, disabled: disabled, className: buttonClass(props), onClick: onClick, onFocus: onFocus, onBlur: onBlur, onMouseDown: function (e) { return onMouseDown && onMouseDown(e); }, "aria-label": generateAriaLabel(props), "aria-disabled": disabled || props.working ? true : undefined, form: form, formAction: formAction, formMethod: formMethod, formEncType: formEncType, formTarget: formTarget, formNoValidate: formNoValidate, tabIndex: disableTabFocusAndIUnderstandTheAccessibilityImplications
            ? -1
            : undefined, ref: ref }, customProps), renderContent(props)));
};
var renderLink = function (props, ref) {
    var id = props.id, href = props.href, onClick = props.onClick, newTabAndIUnderstandTheAccessibilityImplications = props.newTabAndIUnderstandTheAccessibilityImplications, onFocus = props.onFocus, onBlur = props.onBlur, rest = __rest(props, ["id", "href", "onClick", "newTabAndIUnderstandTheAccessibilityImplications", "onFocus", "onBlur"]);
    var customProps = getCustomProps(rest);
    var target = newTabAndIUnderstandTheAccessibilityImplications
        ? "_blank"
        : "_self";
    return (react_1["default"].createElement("a", __assign({ id: id, href: href, target: target, rel: target === "_blank" ? "noopener noreferrer" : undefined, className: buttonClass(props), onClick: onClick, onFocus: onFocus, onBlur: onBlur, ref: ref, "aria-label": generateAriaLabel(props) }, customProps), renderContent(props)));
};
var buttonClass = function (props) {
    var isDefault = !props.primary && !props.destructive && !props.secondary;
    return (0, classnames_1["default"])(GenericButton_module_scss_1["default"].button, isDefault && GenericButton_module_scss_1["default"]["default"], props.primary && GenericButton_module_scss_1["default"].primary, props.destructive && GenericButton_module_scss_1["default"].destructive, props.secondary && GenericButton_module_scss_1["default"].secondary, props.size && GenericButton_module_scss_1["default"][props.size], props.reversed && GenericButton_module_scss_1["default"].reversed, props.iconButton && GenericButton_module_scss_1["default"].iconButton, props.working && GenericButton_module_scss_1["default"].working, (props.directionalLink || props.paginationLink) && GenericButton_module_scss_1["default"].circleButton, props.directionalLink && GenericButton_module_scss_1["default"].directionalLink, props.paginationLink && GenericButton_module_scss_1["default"].paginationLink, props.isActive && GenericButton_module_scss_1["default"].isPaginationLinkActive, props.classNameOverride);
};
var renderLoadingSpinner = function () { return (react_1["default"].createElement("div", { className: GenericButton_module_scss_1["default"].loadingSpinner },
    react_1["default"].createElement(loading_spinner_1.LoadingSpinner, { accessibilityLabel: "", size: "sm" }))); };
var renderWorkingContent = function (props) {
    if (props.workingLabelHidden) {
        return (react_1["default"].createElement(react_1["default"].Fragment, null,
            react_1["default"].createElement("span", { className: GenericButton_module_scss_1["default"].hidden, "aria-hidden": "true" }, renderDefaultContent(props)),
            react_1["default"].createElement("span", { className: GenericButton_module_scss_1["default"].centeredLoadingSpinner }, renderLoadingSpinner())));
    }
    return (react_1["default"].createElement(react_1["default"].Fragment, null,
        props.iconPosition !== "end" && renderLoadingSpinner(),
        react_1["default"].createElement("span", { className: GenericButton_module_scss_1["default"].label }, props.workingLabel),
        props.additionalContent && (react_1["default"].createElement("span", { className: GenericButton_module_scss_1["default"].additionalContentWrapper }, props.additionalContent)),
        props.iconPosition === "end" && renderLoadingSpinner()));
};
var renderDefaultContent = function (props) { return (react_1["default"].createElement(react_1["default"].Fragment, null,
    props.icon && props.iconPosition !== "end" && renderIcon(props.icon),
    (!props.icon || !props.iconButton) && (react_1["default"].createElement("span", { className: GenericButton_module_scss_1["default"].label }, props.label)),
    props.additionalContent && (react_1["default"].createElement("span", { className: GenericButton_module_scss_1["default"].additionalContentWrapper }, props.additionalContent)),
    renderBadge(props),
    props.icon && props.iconPosition === "end" && renderIcon(props.icon))); };
var renderBadge = function (props) {
    if (!props.badge)
        return null;
    var _a = props.badge, text = _a.text, animateChange = _a.animateChange, reversed = _a.reversed, variant = _a.variant;
    if (animateChange) {
        return (react_1["default"].createElement(draft_badge_1.BadgeAnimated, { variant: variant, reversed: reversed }, text));
    }
    return (react_1["default"].createElement(draft_badge_1.Badge, { variant: variant, reversed: reversed }, text));
};
var renderContent = function (props) { return (react_1["default"].createElement("span", { className: GenericButton_module_scss_1["default"].content }, props.working ? renderWorkingContent(props) : renderDefaultContent(props))); };
var renderIcon = function (icon) { return (react_1["default"].createElement("span", { className: GenericButton_module_scss_1["default"].iconWrapper },
    react_1["default"].createElement(component_library_1.Icon, { icon: icon, role: "presentation" }))); };
// We only want an aria-label in the case that the button has just an icon and no text
// This can happen when the button is working and workingLabelHidden is true,
// or when this is an IconButton
var generateAriaLabel = function (props) {
    if (props.working && props.workingLabelHidden) {
        return props.workingLabel;
    }
    if (props.iconButton) {
        return props.label;
    }
    return undefined;
};
exports["default"] = GenericButton;
//# sourceMappingURL=GenericButton.js.map